import React, { useState } from 'react';
import { connect } from "react-redux";
import Logo from "../../assets/images/logo-white.svg";
import { createSession, registerUser } from '../../RestUtil.js';
import styled from 'styled-components';

const LoginLink = styled.a`
  background: "#BF4F74";
  color: "white";
  font-size: 1em;
  margin: 1em;
  padding: 0.25em 1em;
  border: 2px solid #BF4F74;
  border-radius: 3px;  cursor: pointer;
  `;

  export default function Registration() {

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [deviceSerial, setDeviceSerial] = useState("");
    const [email, setEmail] = useState(""); 
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
  
    function handleLogin() {
      window.location = "login";
    }

    const handleEmailChange = (event) => {
      const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
      const newEmail = event.target.value;
      const isValid = emailRegex.test(newEmail);
      const emailErrSpan = document.getElementById("invalidEmailSpan");
      if (!isValid) {
        emailErrSpan.style.display = "block";
      }
      else {
        emailErrSpan.style.display = "none";
        setEmail(newEmail);
      }
    };

    function handleRegister() {
      if (confirmPassword !== password) {
        alert("Confirm password must match");
        return;
      }
      setIsLoading(true);
      //
      // Invoke rest to login
      //
      // 1. create session
      //  
      console.log("handleRegister");
      createSession().then(resp => {
        console.log("Response",resp);
        let sessionId = resp.id;
        console.log("Session Id",sessionId);
        registerUser(sessionId, email, password, firstName, lastName, deviceSerial).then(resp => {
          console.log("registerSuccess",resp);
          setIsLoading(false);
          alert("Registration Success");
          window.location = "login";
        })
        .catch(err => {
          console.log("registerFailed",err);        
          setIsLoading(false);
          alert(err?.response?.data || "Registration Failed");
        });      
      });
    }
    
    return (
      <div className="theme-cyan">
        {isLoading && 
        <div className="page-loader-wrapper" style={{ display: 'block' }}>
          <div className="loader">
            <div className="m-t-30"><img src="images/logo.png" width="48" height="48" alt="Lucid" /></div>
            <p>Please wait...</p>
          </div>
        </div>
        }
        <div >
          <div className="vertical-align-wrap">
            <div className="vertical-align-middle auth-main">
              <div className="auth-box">
                <div className="top">
                  <img src="images/logo2.png" alt="Lucid" style={{ height: "40px", margin: "10px" }} />
                </div>
                <div className="card">
                  <div className="header">
                    <span className="lead">Create a new account</span>
                  </div>
                  <div className="body">
                    <form className="form-auth-small ng-untouched ng-pristine ng-valid">
                      <div className="form-group">
                        <label className="control-label" >First Name</label>
                        <input className="form-control" id="signup-firstname" placeholder="Your First Name" type="text" value={firstName}
                          onChange={val => {
                            setFirstName(val.target.value);
                          }} />
                      </div>
                      <div className="form-group">
                        <label className="control-label" >Last Name</label>
                        <input className="form-control" id="signup-lastname" placeholder="Your Last Name" type="text" value={lastName}
                          onChange={val => {
                            setLastName(val.target.value);
                          }} />
                      </div>
                      <div className="form-group">
                        <label className="control-label" >Device Serial</label>
                        <input className="form-control" id="signup-deviceserial" placeholder="Your Device Serial" type="text" value={deviceSerial}
                          onChange={val => {
                            setDeviceSerial(val.target.value);
                          }} />
                      </div>
                      <div className="form-group">
                        <label className="control-label" >Email</label><span id="invalidEmailSpan" style={{color:"red",display:"none"}}>&nbsp;Invalid email</span>
                        <input className="form-control" id="signup-email" placeholder="Your email" type="text" onChange={handleEmailChange}/>
                      </div>
                      <div className="form-group">
                        <label className="control-label" >Password</label>
                        <input className="form-control" id="signup-password" placeholder="Password" type="password" value={password}
                          onChange={val => {
                            setPassword(val.target.value);
                          }} />
                      </div>
                      <div className="form-group">
                        <label className="control-label" >Confirm Password</label>
                        <input className="form-control" id="signup-confirm-password" placeholder="Confirm Password" type="password" value={confirmPassword}
                          onChange={val => {
                            setConfirmPassword(val.target.value);
                          }} />
                      </div>
                      <button className="btn btn-primary btn-lg btn-block" type="button" onClick={handleRegister}>
                        REGISTER
                        </button>
                      <div className="bottom">
                        <span className="helper-text">
                          Already have an account?{" "}
                          <LoginLink onClick={handleLogin}>Login</LoginLink>
                        </span>
                      </div>
                    </form>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    );
}
